import { FC } from "react";

import { RideStartEndDateEditableAddition } from "./additions";

export const TableCellAdditions: FC = () => {
  return <RideStartEndDateEditableAddition />;
};
